export const monthMap = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

const biMonthlyOptions = {
  '1,3,5,7,9,11': [1, 3, 5, 7, 9, 11],
  '2,4,6,8,10,12': [2, 4, 6, 8, 10, 12],
};

const quarterlyOptions = {
  '1,4,7,10': [1, 4, 7, 10],
  '2,5,8,11': [2, 5, 8, 11],
  '3,6,9,12': [3, 6, 9, 12],
};

const semiAnnuallyOptions = {
  '1,7': [1, 7],
  '2,8': [2, 8],
  '3,9': [3, 9],
  '4,10': [4, 10],
  '5,11': [5, 11],
  '6,12': [6, 12],
};

const triAnnuallyOptions = {
  '1,5,9': [1, 5, 9],
  '2,6,10': [2, 6, 10],
  '3,7,11': [3, 7, 11],
  '4,8,12': [4, 8, 12],
};

const generateOptions = keyOptions =>
  Object.keys(keyOptions).map(key => ({
    name: keyOptions[key]
      .map(mon => shortenMonth(monthMap[mon]))
      .toString()
      .replace(/([,])/g, ' - '),
    code: key,
  }));

const shortenMonth = month => month.slice(0, 3);

export const periodicityHash = {
  monthly: Object.keys(monthMap).map(key => ({
    name: monthMap[key],
    code: '1,2,3,4,5,6,7,8,9,10,11,12',
  })),
  monthly_extension: Object.keys(monthMap).map(key => ({
    name: monthMap[key],
    code: '1,2,3,4,5,6,7,8,9,10,11,12',
  })),
  annually: Object.keys(monthMap).map(key => ({ name: monthMap[key], code: key })),
  'bi-monthly': generateOptions(biMonthlyOptions),
  quarterly: generateOptions(quarterlyOptions),
  quarterly_extension: generateOptions(quarterlyOptions),
  'semi-annually': generateOptions(semiAnnuallyOptions),
  'tri-annually': generateOptions(triAnnuallyOptions),
};

export const periodicityValues = {
  1: [1],
  2: [2],
  3: [3],
  4: [4],
  5: [5],
  6: [6],
  7: [7],
  8: [8],
  9: [9],
  10: [10],
  11: [11],
  12: [12],
  default_ending_months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  '1,2,3,4,5,6,7,8,9,10,11,12': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  '1,3,5,7,9,11': [1, 3, 5, 7, 9, 11],
  '2,4,6,8,10,12': [2, 4, 6, 8, 10, 12],
  '1,4,7,10': [1, 4, 7, 10],
  '2,5,8,11': [2, 5, 8, 11],
  '3,6,9,12': [3, 6, 9, 12],
  '1,7': [1, 7],
  '2,8': [2, 8],
  '3,9': [3, 9],
  '4,10': [4, 10],
  '5,11': [5, 11],
  '6,12': [6, 12],
  '1,5,9': [1, 5, 9],
  '2,6,10': [2, 6, 10],
  '3,7,11': [3, 7, 11],
  '4,8,12': [4, 8, 12],
};

export const dayMonthHash = Array.from(new Array(31).keys());

/**
 * @typedef {string} RegistrationStatus
 **/

/**
 * @enum {RegistrationStatus}
 */
export const REGISTRATION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'deregistered',
  DELETED: 'deleted',
};

/**
 * @typedef {string} RegistrationTab
 **/

/**
 * @enum {RegistrationTab}
 */
export const REGISTRATION_TAB = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
